<template>
    <div>
        <div v-if="options_loaded && passed_filter">
            <template v-if="filtered_option_list.length > 0 && filtered_option_list[0].value !== null">
                <div class="designeroption" :data-designer-component-id="component_id">
                    <h3>{{ title }}</h3>
                    <div class="stylesoption selectoption form-group">
                        <select :id="'question--' + component_id" class="form-control" v-model="localTarget" v-if="!loading">
                            <option v-for="option in filtered_option_list" :value="option.value">{{ option.label }}</option>
                        </select>
                        <select :id="'question--' + component_id" disabled class="form-control" v-if="loading">
                            <option>Loading Options...</option>
                        </select>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return 'Hardware Cylinder';
                }
            },
            component_id: {
                default(){
                    return 'hardware_cylinder_stable';
                }
            },
            slab: {
                required: true
            },
            hardwareHandle: {
                required: true
            },
            hardwareLock: {
                required: true
            },
            hardwareColour: {
                required: true
            },
            hardwareCylinder: {
                required: true
            },
            securedByDesign: {
                default(){
                    return '1';
                }
            },
            doorRange: {
                required: true
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.hardwareHandle, this.hardwareLock, this.hardwareColour, this.securedByDesign, this.slab, this.hardwareCylinder, this.doorRange);
            },
            url(){
                return '/api/options/' + this.fabricator + '/hardware-cylinder-stable?slab=' + this.slab + '&hardware_colour=' + this.hardwareColour + '&hardware_handle=' + this.hardwareHandle + '&hardware_lock=' + this.hardwareLock + '&secured_by_design=' + this.securedByDesign + '&hardware_cylinder=' + this.hardwareCylinder + '&door_range=' + this.doorRange;
            },
            cache_key(){
                return '_' + this.hardwareHandle + '_' + this.hardwareLock + '_' + this.hardwareColour + '_' + this.securedByDesign + '_' + this.slab + '_' + this.hardwareCylinder + '_' + this.doorRange;
            }
        },
        watch: {
            'hardwareHandle': function (val, oldVal) {
                this.select_first_after_update = true;
                this.update_options();
            },
            'hardwareLock': function (val, oldVal) {
                this.update_options();
            },
            'hardwareColour': function (val, oldVal) {
                this.update_options();
            },
            'securedByDesign': function (val, oldVal) {
                this.select_first_after_update = true;
                this.update_options();
            },
            'slab': function (val, oldVal) {
                this.update_options();
            },
            'hardwareCylinder': function (val, oldVal) {
                this.update_options();
            },
            'doorRange': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
